export enum ToastType {
  INFO = "default",
  WARNING = "warning",
  ERROR = "danger",
  SUCCESS = "success",
}
